import React, { useEffect } from 'react'

import { ScrollView, StyleSheet, TouchableOpacity } from 'react-native'

import { Title, Text, Space, MenuList } from '@sart/components'
import { adaptive, colors, typography } from '@sart/styles'
import client, { useData } from '@sart/client'

export default function TermsAndConditions(props) {
  const { navigation } = props

  const [{ termsAndConditionsItems, error, loading }, setData] = useData({})

  
  useEffect(() => {
    getTermsAndConditionsItems()
  }, [])

  async function getTermsAndConditionsItems() {
    setData({ loading: true })
    try {
      const termsAndConditionsItems =  await client.callApi('contentCms','getPages',[1, { category: "TERMSANDCONDITIONS" }]);
      const parsedItems = termsAndConditionsItems.map(item => {
        let excerpt = {}
        try {
          excerpt = JSON.parse(item.excerpt)
        } catch(error) {
          return {}
        }
        // let excerpt = JSON.parse(item.excerpt)
        // let content = JSON.parse(item.excerpt)
        let parsed = {};
        parsed.rank = excerpt.rank;
        parsed.title = excerpt.title;
        parsed.content = excerpt.description;
        return parsed;
      });
      const orderedItems = parsedItems.sort(function(a,b) {
        return a.rank - b.rank;
      })
      setData({
        termsAndConditionsItems: orderedItems,
        loading: false
      })
      client.setCache({
        termsAndConditionsItems: orderedItems
      })
    } catch (error) {
      // TODO: handle error
      console.log('error is: ');
      console.log(error);
      setData({ loading: true, error })
    }
  }

  return (
    <ScrollView style={styles.wrapper}>
    {termsAndConditionsItems &&
      <MenuList>
        {
          termsAndConditionsItems.map(item =>
            <TouchableOpacity onPress={() => navigation.navigate('TermsAndConditionsItem', {item})}>
              <Space height={10} />
                <Text style={styles.titleText}>{item.title}</Text>
            </TouchableOpacity>
          )
        }
      </MenuList>
    }
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
  },
  titleText: {
    textAlign: 'center',
    ...typography.demi,
    fontSize: 16
  }
})
